@if (loggedIn()) {
  <router-outlet></router-outlet>
}
@if (!loggedIn() && !loggingIn()) {
  <login-page></login-page>
}
@if (!loggedIn() && loggingIn()) {
  <div style="position: absolute; left: calc(50% - 100px); top: calc(50% - 50px)">
    Logging in ...<i class="fas fa-spinner fa-spin"></i></div>
  }
  @if (!loggedIn() && loggingIn()) {
    <button class="btn cl-btn-micro" style="position: absolute; right: 0; bottom: 0"
      (click)="cleanLocalStorage()">Clean
      Local Storage
    </button>
  }
